import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["locations", "listing", "className"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import classNames from 'classnames';
import DixuCard from "../DixuCard/DixuCard";
import DixuDescriptionList from "../DixuDescriptionList/DixuDescriptionList";
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuMap from "../DixuMap/DixuMap";
import { useTranslation } from "../../i18n";
import React from 'react';
import { getPostalCodeDetails } from "../../utils/DixuListingUtils";
const DixuLocationInfo = _ref => {
  let {
      locations,
      listing,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useTranslation(['listing']);
  const classes = classNames('dixu-location-info', className);
  const {
    mapCoordinates,
    address
  } = listing || {};
  return /*#__PURE__*/React.createElement(DixuCard, _objectSpread({
    className: classes,
    title: t('listing:ListingDetails.Location')
  }, rest), /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [40, 40]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    md: 8,
    xl: 6
  }, /*#__PURE__*/React.createElement(DixuDescriptionList, {
    items: locations,
    sortByName: false,
    sortByValue: true,
    autoNameWidth: true
  })), /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    md: 16,
    xl: 18
  }, /*#__PURE__*/React.createElement(DixuMap, {
    mapCoordinates: mapCoordinates,
    query: [address, getPostalCodeDetails(listing)].filter(Boolean).join(', ')
  }))));
};
export default DixuLocationInfo;